import { IRootState } from "app/model"
import { getActiveAppContext } from "app/tools/common"
import { IForm } from "form/model"
import { getForm } from "form/tools/common"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { AudienceList } from "./audience/AudienceList"

interface IContentAudienceProps {
  form: IForm | null
  isTightContent: boolean
}

const ContentAudienceFn = React.memo(({ form, isTightContent }: IContentAudienceProps) => {
  if (!form) {
    return null
  }
  return (
    <FlexBox
      gap
      fullWidth
      sx={{
        "height": "100%",
        "mt": 0,
        "& > *": {
          width: "100%"
        }
      }}>
      <AudienceList form={form} />
    </FlexBox>
  )
})

export const ContentAudience = connect(
  (state: IRootState): IContentAudienceProps => ({
    form: getActiveAppContext(state) ? getForm(state) : null,
    isTightContent: state.ui.contentWidth < 760
  })
)(ContentAudienceFn)
